<template>
  <div class="framed-table">
    <!-- O scroll horizontal fica no involucro, nunca no <table>: display:block
         na tabela solta as colunas do cabecalho em tela pequena. -->
    <div class="framed-table__scroll">
      <table class="table framed-table__table" :class="{ 'table-striped': striped }">
        <slot/>
      </table>
    </div>
    <!-- Rodape dentro da moldura (paginacao, totais). Opcional. -->
    <div class="framed-table__footer" v-if="$slots.footer">
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
/**
 * Moldura padrao das tabelas de Avisos e Campanhas e Liberacoes: borda 1px
 * #d5d7da, raio 6px, cabecalho com linha da mesma cor. O conteudo (thead e
 * tbody) vem pelo slot padrao, sem opiniao sobre colunas.
 *
 * `striped: false` para tabela com um <tbody> por linha (detalhe expansivel):
 * o zebrado do Bootstrap conta as linhas DENTRO de cada tbody, e ali toda
 * linha principal sairia listrada.
 */
export default {
  name: 'framed-table',
  props: {
    striped: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.framed-table {
  border: 1px solid #d5d7da;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.framed-table__scroll { overflow-x: auto; }
.framed-table__table { margin: 0; font-size: 13px; }
.framed-table__table > thead > tr > th { border-bottom: 1px solid #d5d7da; }
.framed-table__footer { border-top: 1px solid #d5d7da; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/framedTable.vue